import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("loginmaster", ["setPlan"]),
    async categoryChanged() {
      this.payload.institution = null; // If the type is changed, reset the select Object. set the institution property to null
      this.payload.subjects = []; // Empty the subjects property Array
      this.payload.topics = []; // Empties the Topics Array
      this.payload.mode = "Prototype"; // Set it to the default mode
      this.institutionsArray = []; // Empties the Institutions Array

      await this.fetchInstitutionsData();

      this.payload.organization = this.details.category == 'Individual' ? this.details.quicktest_details.organization_name : this.details.org_details.organization_name


      let category = this.categoriesArray.find(
        x => (x.organization_name == this.payload.organization && x.name == this.payload.category) 
      );
      
      this.sameName = category?.sameName;

      if (this.sameName == "Yes") {
        let institution = this.allinsti.find(
          x =>
            x.name == this.payload.category && x.organization_name == this.payload.organization
        );

        this.currentInstitutionObj = institution;

        this.payload.institution = institution.name;
        this.payload.institution_id = institution.track_id;

        this.subjectsArray = JSON.parse(institution.subjects_offered);
        this.structure = institution.structure;

        this.payload.institution_id = institution.track_id;

        let parsedCompulsorySubjects = JSON.parse(
          institution.compulsory_subjects
        );

        parsedCompulsorySubjects.forEach(subject => {
          // If 'all' is the value in the Compulsory subject array, then it means all the subjects are compulsory
          // Therefore push all the subjects in the 'subjectsArray' into the 'subject' property of the select Object
          if (subject.toLowerCase() == "all") {
            this.subjectsArray.forEach(subject2 => {
              this.payload.subjects.push(subject2);
            });
          } else {
            // Push the items in the Compulsory Array one by one into the 'subject' property of the select Object
            this.payload.subjects.push(subject);
          }
        });

        this.currentStep = 3;
      } else {
        this.currentStep = 2;
      }
    },
    institutionChanged() {
      let institution = this.institutionsArray.find(
        x => x.track_id == this.payload.institution_id
      );

      this.currentInstitutionObj = institution;

      this.payload.institution = institution.name;
      this.structure = institution.structure;
      this.payload.institution_shortname = institution.short_name;

      if ((this.structure == "Subject" || this.structure == "Untabbed") && this.currentInstitutionObj?.premium && this.currentStep == 2) {
        this.setPlan("Premium");
      } else if((this.structure == "Subject" || this.structure == "Untabbed") && !this.currentInstitutionObj?.premium && this.currentStep == 2) {
        this.setPlan("Free");
      }

      this.levelsArray = []; // Anytime user changes Institution, empty the levelsArray

      if (this.structure == "Section") {
        // Get the levels config Object for this particular institution under the undergraduate category
        // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
        let unparsedLevelConfig = institution.levels_config;
        let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string
        this.payload.subjects = []; // Clear the subject property of the select Object anytime the user changes Institution
        this.levelsArray = parsedLevelConfig.map(x => ({
          text: x.name,
          value: x.name
        }));

        this.poolPremiumLevels()

        this.currentStep = 3;
      } else if (this.structure == "Subject") {
        // Get the Subjects available for this Institution from the Institutions Object and map them to 'unparsedSubjects'
        let unparsedSubjects = institution.subjects_offered;
        this.subjectsArray = JSON.parse(unparsedSubjects); // parse the Array and set the value of the data property 'subjectsArray' to it
        this.payload.subjects = [];
        let unparsedCompulsorySubjects = institution?.compulsory_subjects;
        let parsedCompulsorySubjects = JSON.parse(unparsedCompulsorySubjects);
        let subjectsArray = JSON.parse(unparsedSubjects);

        // Loop through the Compulsory Array and perform a function for each Function
        parsedCompulsorySubjects.forEach(subject => {
          // If 'all' is the value in the Compulsory subject array, then it means all the subjects are compulsory
          // Therefore push all the subjects in the 'subjectsArray' into the 'subject' property of the select Object
          if (subject.toLowerCase() == "all") {
            subjectsArray.forEach(subject2 => {
              this.payload.subjects.push(subject2);
            });
          } else {
            // Push the items in the Compulsory Array one by one into the 'subject' property of the select Object
            this.payload.subjects.push(subject);
          }
        });

        this.currentStep = 3;
      }else if (this.structure == "Untabbed") {
        this.currentStep = 3;
      }
    },
    levelChanged() {
      let institution = this.institutionsArray.find(
        x => x.track_id == this.payload.institution_id
      );

      let currentLevelObj = this.levelsArray.find(
        x => x.value == this.payload.level
      );

      if ((this.structure == "Subject" || this.structure == "Untabbed") && this.currentInstitutionObj?.premium && this.currentStep == 2) {
        this.setPlan("Premium");
      } else if((this.structure == "Subject" || this.structure == "Untabbed") && !this.currentInstitutionObj?.premium && this.currentStep == 2) {
        this.setPlan("Free");
      }

      if (this.structure == "Section" && currentLevelObj?.premium && this.currentStep == 3) {
        this.setPlan("Premium");
      } else if (this.structure == "Section" && !currentLevelObj?.premium && this.currentStep == 3){
        this.setPlan("Free");
      }

      this.coursesArray = [];
      // Get the levels config Object for this particular institution under the undergraduate category
      // The Levels Configuration Object contains all the Configuration for each level and courses available under the selected institution
      let unparsedLevelConfig = institution.levels_config;
      let parsedLevelConfig = JSON.parse(unparsedLevelConfig); // Parse the levels config from string

      // Get the Chosen Level exact config Array.
      // To see output. Console.log(config) in development mode
      let config = parsedLevelConfig.find(x => x.name == this.payload.level)
        ?.config;
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config
        ?.find(x => x.name == "courses")
        ?.values?.map(x => ({ text: x, value: x }));
      // Inject this Array into the general courses Array for Selection
      this.coursesArray = courses;

      this.currentStep = 4;
    },
    topicMode() {
      if (this.payload.mode == "Topic") {
        let categoryconfig = this.categoriesArray.filter(
          x => x.name == this.payload.category
        );

        if (categoryconfig[0].structure == "Section") {
          let currentTopics = this.alltopics
            .filter(
              x =>
                x.topic_for == this.payload.course &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map(x => x.topic);

          this.topicsArray = currentTopics;
        } else if (categoryconfig[0].structure == "Subject") {
          let currentTopics = this.alltopics
            .filter(
              x =>
                x.topic_for == this.payload.subjects[0] &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map(x => x.topic);

          this.topicsArray = currentTopics;
        }else if (categoryconfig[0].structure == "Untabbed") {
          let currentTopics = this.alltopics
            .filter(
              x =>
                x.topic_for == this.payload.institution &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map(x => x.topic);

          this.topicsArray = currentTopics;
        }
      }
    }
  }
};
